// NDJSON over fetch (docs/CONTRACTS.md section 8): one JSON value per line, read with body.getReader().
// No EventSource anywhere in the app.

/** Yields each parsed line of an NDJSON body; a blank line is skipped, a line that is not JSON throws. */
export async function* readNdjson(body: ReadableStream<Uint8Array>, signal?: AbortSignal): AsyncGenerator<unknown> {
  const reader = body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  const onAbort = () => void reader.cancel().catch(() => {})
  signal?.addEventListener('abort', onAbort, { once: true })
  try {
    for (;;) {
      const { value, done } = await reader.read()
      buffer += done ? decoder.decode() : decoder.decode(value, { stream: true })
      let newline = buffer.indexOf('\n')
      while (newline >= 0) {
        const line = buffer.slice(0, newline).trim()
        buffer = buffer.slice(newline + 1)
        if (line) yield JSON.parse(line)
        newline = buffer.indexOf('\n')
      }
      if (done) break
    }
    const rest = buffer.trim()
    if (rest) yield JSON.parse(rest)
  } finally {
    signal?.removeEventListener('abort', onAbort)
    reader.releaseLock()
  }
}
